import type { BlockAnimation } from '../types';

export function getAnimationClassName(animation: BlockAnimation): string | undefined {
  switch (animation.type) {
    case 'fade_in':
      return 'fade-in';
    case 'slide_in':
      switch (animation.direction) {
        case 'down':
          return 'slide-in-down';
        case 'up':
          return 'slide-in-up';
        case 'left':
          return 'slide-in-left';
        case 'right':
          return 'slide-in-right';
        default:
          return 'slide-in-up';
      }
    case 'scale_in':
      switch (animation.scaleTo) {
        case 'grow':
          return 'scale-in-grow';
        case 'shrink':
          return 'scale-in-shrink';
        default:
          return 'scale-in-grow';
      }
    default:
      return undefined;
  }
}
